import React from "react";

export default function MarqueeOptionsQuoteTable ({ quoteDetails }) {
    return (
        <div className="quote-options">
            <div className="quote-options__table">
                <div className="quote-options__table-header">
                    <div>Recommended Marquee</div>
                </div>

                <div className="quote-options__table-rows">
                    <div className="quote-options__table-row">
                        <div className="quote-options__table-row-item">{quoteDetails.marquee.size}</div>
                        <div className="quote-options__table-row-item quote-options__table-row-item--recommended">£{quoteDetails.marquee.value}</div>
                    </div>
                    <div className="quote-options__table-row">
                        <div className="quote-options__table-row-item">Carpet, Anthracite</div>
                    </div>

                    <div className="quote-options__table-row">
                        <div className="quote-options__table-row-item">Hard Flooring System laid to ground conditions</div>
                    </div>

                    <div className="quote-options__table-row">
                        <div className="quote-options__table-row-item">Pleated White Marquee Linings, Swags</div>
                    </div>
                </div>
            </div>

            {quoteDetails.marqueeOptions.length ? (
                <div className="quote-options__table">
                    <div className="quote-options__table-rows">
                        <div className="quote-options__table-row quote-options__table-row--header">
                            <div className="quote-options__table-row-item">Options Selected</div>
                            <div className="quote-options__table-row-item">Unit Price</div>
                            <div className="quote-options__table-row-item">Number Required</div>
                            <div className="quote-options__table-row-item">Total Price</div>
                        </div>


                        {quoteDetails.marqueeOptions.map((option, index) => (
                            <div key={index} className="quote-options__table-row">
                                <div className="quote-options__table-row-item">{option.optionName}</div>
                                <div className="quote-options__table-row-item">£{Number(option.value) / Number(option.quantity)}</div>
                                <div className="quote-options__table-row-item">{option.quantity}</div>
                                <div className="quote-options__table-row-item">£{option.value}</div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : null}

            <div className="quote-options__totals">
                <div className="quote-options__totals-group">
                    {quoteDetails.distancePrice &&
                        <div className="quote-options__totals-distance-total">
                            <span>Delivery and Installation:</span>
                            <span>£{quoteDetails.distancePrice}</span>
                        </div>
                    }

                    <div className="quote-options__totals-sub-total"><span>Sub Total:</span><span>£{quoteDetails.price}</span></div>
                    <div className="quote-options__totals-vat"><span>VAT:</span><span>£{Number(quoteDetails.price) * 0.20}</span></div>
                    <div className="quote-options__totals-total"><span>Total:</span><span>£{quoteDetails.VATPrice}</span></div>
                </div>

                <div className="quote-options__totals-deposit">
                    <div className="quote-options__totals-deposit-percent">20% Deposit Payable</div>
                    <div className="quote-options__totals-deposit-total">£{Number(quoteDetails.price) * 0.20}</div>
                </div>
            </div>
        </div>
    )
}